import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2768_509)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.70538 9.29446C7.09466 8.90519 7.72569 8.90484 8.11538 9.29369L12 13.1698L15.8846 9.29369C16.2743 8.90484 16.9053 8.90519 17.2946 9.29446C17.6842 9.68403 17.6842 10.3157 17.2946 10.7052L12.7071 15.2927C12.3166 15.6833 11.6834 15.6833 11.2929 15.2927L6.70538 10.7052C6.31581 10.3157 6.31581 9.68403 6.70538 9.29446Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2768_509",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgArrowDown;
